<template>
    <b-container>
        <img id="img-manutencao" class="img-fluid" src="../assets/images/manutencao.png" alt="Imagem Manutencao"
            title="Imagem Manutencao" />
        <div class="manut-text-box container-fluid">
            <h4>Plataforma em manutenção</h4>
            <p>
                Estamos realizando uma manutenção programada e o acesso ficará
                indisponível temporariamente. Não se preocupe pois suas conversões não
                serão impactadas. <br /><br />
            </p>
            <p id="date-of-conclusion">
                <strong>{{ dateOfConclusionMsg }}</strong><br />
                Agradecemos a compreensão.
            </p>
        </div>
    </b-container>
</template>

<script>
import store from '@/store';

export default {
  name: 'Maintenance',
  components: {},
  data() {
    return {
      title: 'Manutencao',
      dateOfConclusionMsg: 'A previsão para a normalização da plataforma é de até às xx h do dia xx/xx/xxxx.',
    };
  },
  methods: {
    async loadOnMaintenance() {
      await store.dispatch('getItsOnMaintenance');
      const { maintenanceMessage } = store.getters;

      this.dateOfConclusionMsg = maintenanceMessage;
    },
  },
  created() {
    this.loadOnMaintenance();
  },
};
</script>

<style lang="scss" scoped>
* {
    font-family: UOLtext, 'Open Sans', 'Helvetica Neue', sans-serif;
    text-align: center;
}

#img-manutencao {
    max-height: 300px;
    margin-top: 60px;
}

.manut-text-box {
    margin: 0 auto 136px auto;
    font-size: 18px;
}

.manut-text-box>h4 {
    margin-top: 20px;
    margin-bottom: 14.5px;
    font-size: 24px;
    font-weight: 600;
}

@media only screen and (min-width: 768px) {
    .manut-text-box {
        max-width: 72%;
    }
}
</style>
